import React, { useState } from 'react';
import { Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox } from '@mui/material';

const initialPermissions = [
  { id: 1, name: 'View Dashboard', admin: true, editor: true, viewer: true },
  { id: 2, name: 'Manage Users', admin: true, editor: false, viewer: false },
  { id: 3, name: 'Edit Bot Configuration', admin: true, editor: true, viewer: false },
  { id: 4, name: 'View Analytics', admin: true, editor: true, viewer: true },
  { id: 5, name: 'Manage Integrations', admin: true, editor: true, viewer: false },
];

const AccessControls = () => {
  const [permissions, setPermissions] = useState(initialPermissions);

  const handlePermissionChange = (permissionId, role) => {
    setPermissions(permissions.map(permission =>
      permission.id === permissionId
        ? { ...permission, [role]: !permission[role] }
        : permission
    ));
  };

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>Access Controls</Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Permission</TableCell>
              <TableCell align="center">Admin</TableCell>
              <TableCell align="center">Editor</TableCell>
              <TableCell align="center">Viewer</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {permissions.map((permission) => (
              <TableRow key={permission.id}>
                <TableCell component="th" scope="row">
                  {permission.name}
                </TableCell>
                <TableCell align="center">
                  <Checkbox
                    checked={permission.admin}
                    onChange={() => handlePermissionChange(permission.id, 'admin')}
                  />
                </TableCell>
                <TableCell align="center">
                  <Checkbox
                    checked={permission.editor}
                    onChange={() => handlePermissionChange(permission.id, 'editor')}
                  />
                </TableCell>
                <TableCell align="center">
                  <Checkbox
                    checked={permission.viewer}
                    onChange={() => handlePermissionChange(permission.id, 'viewer')}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default AccessControls;
